import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue18 } from '../../../../Fct/generics';
import { FaDollarSign } from 'react-icons/fa';
import { getAaveTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { PRICE_ORACLE_ADDRESSES } from '../constants';
export var GetAssetPrice = createPlugin({
    protocol: 'AAVE',
    type: 'ORACLE',
    method: 'getAssetPrice',
    supportedContracts: PRICE_ORACLE_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    asset: new FctAddress({ options: getAaveTokens({ chainId: chainId }), isPreview: true, icon: FaDollarSign }),
                },
            },
            output: {
                price: new FctValue18({ innerIndex: 0 }),
            },
        });
    },
});
